module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mmsbnp6-61d30e51f44ed7ffd5b4c4faf81b8dd2.jpg";